"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ModalFooter extends _react.Component {
  constructor(props) {
    super(props);
    const {
      children,
      html
    } = props;
    if (children && html) {
      throw new Error('Passing children or html props is exclusive. You may only use one at a time.');
    }
  }
  render() {
    const {
      className,
      noPadding,
      children,
      html
    } = this.props;
    const content = html ? /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: html
      }
    }) : children;
    const classes = (0, _classnames.default)('Modal-footer', {
      'Modal-footer-flush': noPadding
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: node => {
        this._container = node;
      },
      className: classes
    }, content);
  }
}
exports.default = ModalFooter;